import { useCallback } from 'react';
import { usePaginationContext } from './usePaginationContext.js';
import '../PaginationContext.js';
import '@emotion/react';

const usePaginationPerPageSelect = _ref => {
  let {
    onItemsPerPageChange
  } = _ref;
  const paginationContext = usePaginationContext();
  const handleSelectChange = useCallback(e => {
    onItemsPerPageChange(parseInt(e.target.value, 10));
  }, [onItemsPerPageChange]);
  return {
    paginationContext,
    handleSelectChange
  };
};

export { usePaginationPerPageSelect };
